import { flowRight } from 'lodash/fp';
import PropTypes from 'prop-types';
import React from 'react';
import { pure } from 'recompose';
import withSpinner from 'components/withSpinner';
import { Body, Table, Header, Head, listProvider, withActiveItem } from 'components/list';
import ListItemManagementAct from './ListItemManagementAct';

const ContractTableInner = ({ rip, items }) => (
    <Table>
        <Head>
            <th />
            <Header sortProperty="operationType" text="Type d'opération" />
            <Header sortProperty="compagnyChoice" text="Fournisseur" />
            <Header sortProperty="managementActContractRefAct" text="Référence de l'acte" />
            <Header sortProperty="createdAt" text="Date de création" />
            <Header sortProperty="updatedAt" text="Dernière modification" />
            <Header sortProperty="state" text="Statut de l'acte" />
            <th />
        </Head>
        <Body>
            {items.map((item) => (
                <ListItemManagementAct
                    key={item.id}
                    rip={rip}
                    item={item}
                />
            ))}
        </Body>
    </Table>
);

ContractTableInner.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    rip: PropTypes.shape({}).isRequired,
};

const ContractTable = flowRight([
    listProvider({
        sorts: {
            operationType: { initialOrder: 'asc' },
            compagnyChoice: { initialOrder: 'asc' },
            managementActContractRefAct: { initialOrder: 'asc' },
            createdAt: { initialOrder: 'desc', default: true },
            updatedAt: { initialOrder: 'desc' },
            state: { initialOrder: 'asc' },
        },
        name: 'managementAct',
        type: 'managementAct',
        criteria: ({ rip: { id } }) => ({ ripId: id }),
    }),
    withSpinner,
    withActiveItem,
    pure,
])(ContractTableInner);

export default ContractTable;
